import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path:'/',
    name:'login',
    component: () => import('../views/login.vue')
  },
  {
    path:'/login_admin',
    name:'login_admin',
    component: () => import('../views/login_admin.vue')
  },
  {
    path:'/index',
    name:'index',
    component: () => import('../views/index.vue')
  },
  {
    path:'/index_user',
    name:'index_user',
    component: () => import('../views/index_user.vue')
  },
  {
    path:'/admin',
    name:'admin',
    component: () => import('../views/admin.vue')
  },
  {
    path:'/user',
    name:'user',
    component: () => import('../views/user.vue')
  },
  {
    path:'/recharge',
    name:'充值设置',
    component: () => import('../views/recharge.vue')
  },
  {
    path:'/rule',
    name:'规则设置',
    component: () => import('../views/rule.vue')
  },
  {
    path:'/join',
    name:'join',
    component: () => import('../views/join.vue')
  },
  {
    path:'/media',
    name:'media',
    component: () => import('../views/media.vue')
  },
  {
    path:'/media_list',
    name:'media_list',
    component: () => import('../views/media_list.vue')
  },
  {
    path:'/vip',
    name:'vip',
    component: () => import('../views/vip.vue')
  },
  {
    path:'/vip_list',
    name:'vip_list',
    component: () => import('../views/vip_list.vue')
  },
  {
    path:'/deposit_list',
    name:'deposit_list',
    component: () => import('../views/deposit_list.vue')
  },
  {
    path:'/one_page',
    name:'one_page',
    component: () => import('../views/one_page/list.vue')
  },
  {
    path:'/one_page_detail',
    name:'one_page_detail',
    component: () => import('../views/one_page/detail.vue')
  },
  {
    path:'/one_page_sort',
    name:'one_page_sort',
    component: () => import('../views/one_page/sort.vue')
  },
  {
    path:'/one_page_join',
    name:'申请分享',
    component: () => import('../views/one_page/join.vue')
  },
  {
    path:'/ebook',
    name:'ebook',
    component: () => import('../views/ebook/list.vue')
  },
  {
    path:'/ebook_detail',
    name:'ebook_detail',
    component: () => import('../views/ebook/detail.vue')
  },
  {
    path:'/ebook_join',
    name:'申请分享',
    component: () => import('../views/ebook/join.vue')
  },
  {
    path:'/company_page_sort',
    name:'商家单页分类',
    component: () => import('../views/company/page_sort.vue')
  },
  {
    path:'/company_page_list',
    name:'商家单页列表',
    component: () => import('../views/company/page_list.vue')
  },
  {
    path:'/company_ebook_list',
    name:'商家电子书列表',
    component: () => import('../views/company/ebook_list.vue')
  },
  {
    path:'/company_mine',
    name:'商家个人管理',
    component: () => import('../views/company/mine.vue')
  },
  {
    path:'/company_recharge',
    name:'商家充值管理',
    component: () => import('../views/company/recharge.vue')
  },
  {
    path:'/company_send',
    name:'商家分配管理',
    component: () => import('../views/company/send_record.vue')
  },
  {
    path:'/company_admin',
    name:'商家登陆管理',
    component: () => import('../views/company/admin.vue')
  },
]

const router = new VueRouter({
  mode:'history',
  routes
})

export default router
